import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Stack } from '@bingads-webui-react/fluent-controls';
import { useResponsiveStyles } from '@bingads-webui-campaign-react/common-hooks';

import { SignalsSparkleImg } from '../../media';

const getStyles = () => ({
  root: {
    marginTop: 24,
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    lineHeight: '28px',
    margin: 0,
  },
});

export const AudienceSignalSection = ({ children }) => {
  const i18n = useContext(I18nContext);
  const getResponsiveStyles = useResponsiveStyles(getStyles);

  return (
    <Stack className={classNames('audience-signal-section', getResponsiveStyles('root'))} tokens={{ childrenGap: 16 }}>
      <h2 className={classNames(getResponsiveStyles('title'))}>
        {i18n.getString(_TL_('Signals (Optional)'))}
      </h2>
      <Stack horizontal className={classNames(getResponsiveStyles('description'))} tokens={{ childrenGap: 12 }}>
        <img src={SignalsSparkleImg} alt="" />
        <Stack>
          <span className="audience-signal-main-description">{i18n.getString(_TL_('Signals give us valuable information about who you want to reach.'))}</span>
          <span className="audience-signal-sub-description">{i18n.getString(_TL_('We\'ll use them as a starting point to find customers and determine who sees your ads.'))}</span>
        </Stack>
      </Stack>
      <div className="audience-signal-section-body">
        {children}
      </div>
    </Stack>
  );
};

AudienceSignalSection.propTypes = {
  children: PropTypes.node,
};

AudienceSignalSection.defaultProps = {
  children: null,
};
